module.exports = __webpack_public_path__ + "img/6.f5c9dad9.jpg";